export function getRoomForSensorLocationId (building, sensorLocationId) {
  if (!building || !sensorLocationId) {
    return null
  }

  let roomFound = null
  for (let room of building.room_set) {
    for (let sensorLocation of room.sensorlocation_set) {
      if (sensorLocationId === sensorLocation.id) {
        roomFound = room
      }
    }
  }
  return roomFound
}

export function getSensorLocationInfoForSensorLocationId (building, sensorLocationId) {
  if (!building || !sensorLocationId) {
    return null
  }

  let sensorLocationFound = null
  for (let room of building.room_set) {
    for (let sensorLocation of room.sensorlocation_set) {
      if (sensorLocationId === sensorLocation.id) {
        sensorLocationFound = sensorLocation
      }
    }
  }
  return sensorLocationFound
}

export function getSensorReadingForForSensorLocationId (sensorReadings, sensorLocationId) {
  if (!sensorReadings || !sensorLocationId) {
    return null
  }
  return sensorReadings.filter(sensorReading => sensorReading.sensorlocation === sensorLocationId)[0]
}
